import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@application/config';
import { Observable } from 'rxjs';
import {
  AttendancePolicySetting,
  AttendancePolicySettingRequest,
} from '../entities/attendance-policy-setting.model';

@Injectable({ providedIn: 'root' })
export class AttendancePolicySettingService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(APP_CONFIG).apiUrl.school_service;

  public get(): Observable<AttendancePolicySetting> {
    return this.http.get<AttendancePolicySetting>(`${this.baseUrl}/AttendancePolicy`, {
      withCredentials: true,
    });
  }

  public update(body: AttendancePolicySettingRequest): Observable<AttendancePolicySetting> {
    return this.http.put<AttendancePolicySetting>(`${this.baseUrl}/AttendancePolicy`, body, {
      withCredentials: true,
    });
  }
}
